/* eslint-disable max-lines */
/* eslint-disable no-inline-comments */
/* eslint-disable line-comment-position */
/* eslint-disable  vars-on-top */
/* eslint-disable max-statements */
/* eslint-disable require-jsdoc */
/* eslint-disable max-len */
/* eslint-disable complexity */
/* eslint-disable no-ternary */
/* eslint-disable no-unused-expressions */
/* eslint-disable max-lines-per-function */
$(document).ready(function() {
  var signerrormsg = '.ph-signup__error',
      formFieldError = 'form_field_error ph-form_field_error',
      fnameErrorCls = 'ph-fnameprofile__emptyvalue',
      lnameErrorCls = 'ph-lnameprofile__emptyvalue',
      redoptionborder = 'ph-redoptionborder',
      formErrField = 'form_field_error',
      disablebtn = 'ph-disable-button',
      marketdoubleval = $('#ph-marketdouble').val();

  function marketOptinTogglecheck() {
    if (marketdoubleval === 'true') {
      $('.ph-switchbutton').addClass(disablebtn);
      $('.ph-doubleoptwarning').removeClass('hidden');
    } else {
      $('.ph-switchbutton').removeClass(disablebtn);
      $('.ph-doubleoptwarning').addClass('hidden');
    }
  }

  $(document).on('click', '.ph-upadatepersoanldetails', function() {
    $('.ph-lnameinput').removeClass('ph-form_field_error__code');
    $('.ph-lnameprofile__emptyvalue').addClass('hidden');
    $('.ph-fnameinput').removeClass('ph-' + formErrField);
    $('.ph-fnameprofile__emptyvalue').addClass('hidden');

    $.colorbox({
      maxWidth: '500px',
      width: '90%',
      height: 'auto',
      scrolling: true,
      /* eslint-disable xss/no-mixed-html */
      html: $('.ph-myprofile__editdetailspopup').html(),
      /* eslint-enable xss/no-mixed-html */
      onComplete: function() {
        marketOptinTogglecheck();

        $.colorbox.resize();
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
    $(signerrormsg).removeClass('hidden');
  });
  $(document).on('click', '.ph-upadatecompanydetails', function() {
    var radio = $('.ph-companyradiodef').val(),
        radioSize = $('.ph-companyradiodefSize').val();

    $('#cboxLoadedContent .ph-contactcommon__emptyvalue').addClass('hidden');
    $('#cboxLoadedContent .ph-signup__errorcommon').removeClass('ph-' + formErrField);

    $.colorbox({
      maxWidth: '500px',
      width: '90%',
      height: 'auto',
      scrolling: true,
      /* eslint-disable xss/no-mixed-html */
      html: $('.ph-myprofile__editcompanydetailspopup').html(),
      /* eslint-enable xss/no-mixed-html */
      onComplete: function() {
        $('#cboxLoadedContent #ph-input-phone-number').on('input', function() {
          this.value = this.value.replace(/\D/g, '');
        });
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });

    if (radio === radioSize) {
      $('#cboxLoadedContent #ph-companyradio0').prop('checked', true);
    }
  });

  $(document).on('click', '.ph-successprofile-closebtn', function() {
    $('.ph-personal_message').addClass('hidden');
  });

  $(document).on('blur', '#cboxLoadedContent .ph-firstName', function() {
    var fnameInputCls = '#cboxLoadedContent .ph-firstName',
        inputValue = $(fnameInputCls).val();

    if (inputValue.length > 0) {
      $(fnameInputCls).parents(signerrormsg).removeClass(formFieldError);
      $(fnameInputCls).parents(signerrormsg).find('.' + fnameErrorCls).addClass('hidden');
    }

    $.colorbox.resize();
  });
  $(document).on('blur', '#cboxLoadedContent .ph-lastName', function() {
    var lnameInputCls = '#cboxLoadedContent .ph-lastName',
        inputValue = $(lnameInputCls).val();

    if (inputValue.length > 0) {
      $(lnameInputCls).parents(signerrormsg).removeClass(formFieldError);
      $(lnameInputCls).parents(signerrormsg).find('.' + lnameErrorCls).addClass('hidden');
    }

    $.colorbox.resize();
  });

  $(document).on('click', '.ph-savedetails', function(event) {
    event.preventDefault();

    var varCbox = 'cboxLoadedContent',
        firstName = $('#' + varCbox + ' .ph-firstName').val(),
        lastName = $('#' + varCbox + ' .ph-lastName').val(),
        errorCountCheck = 0;

    if (firstName === '') {
      $('#' + varCbox + ' #ph-firstName .ph-signup__error').addClass('ph-' + formErrField);
      $('.' + fnameErrorCls).removeClass('hidden');
      errorCountCheck = errorCountCheck + 1;
    }

    if (lastName === '') {
      $('#' + varCbox + ' #ph-lastName .ph-signup__error').addClass('ph-' + formErrField);
      $('.' + lnameErrorCls).removeClass('hidden');
      errorCountCheck = errorCountCheck + 1;
    }

    if (errorCountCheck === 0) {
      $('#' + varCbox + ' #updateProfileForm').submit();
    }

    $.colorbox.resize();
  });

  $(document).on('click', '.ph-savesettings', function(event) {
    event.preventDefault();

    var varCbox = 'cboxLoadedContent';


    if ($('.ph-myprofile__editdetailspopup__inner .ph-profile-promotion-value').hasClass('ph-profile_toggle')) {
      $('.ph-myprofile__editdetailspopup__inner .ph-profile-checkbox').val('true');
    } else {
      $('.ph-myprofile__editdetailspopup__inner .ph-profile-checkbox').val('false');
    }

    $('#' + varCbox + ' #updateStoreSettingsForm').submit();


    $.colorbox.resize();
  });

  $(document).on('click', '.ph-savedetailscompany', function() {
    var $form = $('#cboxContent #updateContactDetailsForm'),
        varCbox = 'cboxLoadedContent',
        inputContactperson = $('#' + varCbox + ' .ph-input-main-contactperson').val(),
        inputPhone = $('#' + varCbox + ' .ph-input-phone-number').val(),
        inputEmail = $('#' + varCbox + ' .ph-input-preferred-email').val(),
        errorCountCheck = 0;

    $('#' + varCbox + ' .ph-contactcommon__emptyvalue').addClass('hidden');
    $('#' + varCbox + ' .ph-signup__errorcommon').removeClass('ph-' + formErrField);

    if (inputContactperson === '') {
      $('#' + varCbox + ' #ph-main-contactperson .ph-signup__error').addClass('ph-' + formErrField);
      $('#' + varCbox + ' .ph-contactperson__emptyvalue').removeClass('hidden');
      errorCountCheck = errorCountCheck + 1;
    }

    if (inputPhone === '') {
      $('#' + varCbox + ' #ph-phone-number .ph-signup__error').addClass('ph-' + formErrField);
      $('#' + varCbox + ' .ph-phonenumber__emptyvalue').removeClass('hidden');
      errorCountCheck = errorCountCheck + 1;
    }

    if (ACC.validation.email(inputEmail)) {
      $('#' + varCbox + ' #ph-preferred-email .ph-signup__error').addClass('ph-' + formErrField);
      $('#' + varCbox + ' .ph-preferredemail__emptyvalue').removeClass('hidden');
      errorCountCheck = errorCountCheck + 1;
    }

    if (errorCountCheck === 0) {
      $.ajax({
        url: ACC.config.encodedContextPath + '/my-account/updateContactDetails',
        type: 'POST',
        data: $form.serialize(),
        datatype: 'json',
        scrolling: true,
        success: function() {
          location.reload();
        }
      });
    }

    $.colorbox.resize();
  });

  $(document).on('click', '.ph-canceldetails', function() {
    $.colorbox.close();
  });

  $(document).on('click', '.ph-peronaldetails__close', function() {
    $('.ph-editdetails').addClass('hidden');
  });

  $(document).on('click', '.ph-cancel__passwordpopup', function() {
    var strReset = 'ph-reset-color';

    $('.ph-refreshform').addClass('hidden');
    $('.ph-removecheck').addClass('ph-icon-cross').removeClass('ph-icon-checkmark');
    $('#ph-currentenail').find('.form_field-input').removeClass(redoptionborder);
    $('.ph-currentpassword__emptyvalue').addClass('hidden');
    $('.ph-update-password-button').addClass('ph-disable-button');
    $('#profile-checkNewPassword').val(' ');
    $('#profile-currentPassword').val(' ');
    $('#profile-newPassword').val(' ');
    $('.ph-low-upper-case i, .ph-one-number i, .ph-one-special-char i, .ph-eight-character i, .ph-password-matches i').removeClass(strReset);
    $('.ph-low-upper-case, .ph-one-number, .ph-one-special-char, .ph-eight-character, .ph-password-matches').next().removeClass(strReset);
    $('#cboxLoadedContent .ph-currentpassword__input').removeClass('ph-form_field_error');
    $('#cboxLoadedContent .ph-currentpassword__emptyvalue').addClass('hidden');
    $('.ph-currentpassword__input').parent().removeClass(redoptionborder);
    $.colorbox.close();
  });

  $(document).on('change', 'input:radio[name="titleCode"]', function() {
    $(this).prop('checked', true);
  });

  $(document).on('click', '.ph-myprofile-changepassword', function() {
    $.colorbox({
      maxWidth: '500px',
      width: '90%',
      height: '520px',
      scrolling: true,
      /* eslint-disable xss/no-mixed-html */
      html: $('.ph-myprofile__changepasswordpopup').html(),
      /* eslint-enable xss/no-mixed-html */
      onClosed: function() {
        var strReset = 'ph-reset-color';

        $('.ph-refreshform').addClass('hidden');
        $('.ph-removecheck').addClass('ph-icon-cross').removeClass('ph-icon-checkmark');
        $('#ph-currentenail').find('.form_field-input').removeClass(redoptionborder);
        $('.ph-currentpassword__emptyvalue').addClass('hidden');
        $('#profile-checkNewPassword').val(' ');
        $('#profile-currentPassword').val(' ');
        $('#profile-newPassword').val(' ');
        $('.ph-low-upper-case i, .ph-one-number i, .ph-one-special-char i, .ph-eight-character i, .ph-password-matches i').removeClass(strReset);
        $('.ph-low-upper-case, .ph-one-number, .ph-one-special-char, .ph-eight-character, .ph-password-matches').next().removeClass(strReset);
        $('#cboxLoadedContent .ph-currentpassword__input').removeClass('ph-form_field_error');
        $('#cboxLoadedContent .ph-currentpassword__emptyvalue').addClass('hidden');
        $('.ph-currentpassword__input').parent().removeClass(redoptionborder);
        ACC.common.refreshScreenReaderBuffer();
      }

    });
  });

  $(document).on('click', '.ph-profile-edit-customer-details', function() {
    $('#cboxLoadedContent .ph-contactcommon__emptyvalue').addClass('hidden');
    $('#cboxLoadedContent .ph-signup__errorcommon').removeClass('ph-' + formErrField);

    $.colorbox({
      maxWidth: '500px',
      width: '98%',
      height: '86%',
      scrolling: false,
      fixed: true,
      /* eslint-disable xss/no-mixed-html */
      html: $('.ph-myprofile__editcustomerdetailspopup').html(),
      /* eslint-enable xss/no-mixed-html */
      // Just commenting onComplete: function() {},
      onOpen: function() {
        $('html').css('overflow', 'hidden');
      },
      onClosed: function() {
        $('html').css('overflow', 'auto');
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  });

  $(document).on('click', '.ph-profile-customer-form-cancel', function() {
    $.colorbox.close();
  });

  // eslint-disable-next-line sonarjs/cognitive-complexity
  function validateCustomerDetailsField(ele) {
    var $ele = $(ele),
        regex = new RegExp($ele.data('validation-regex')),
        inpMandatory = $ele.data('validation-mandatory'),
        validationErrMsg = $ele.data('validation-error-msg'),
        validationRegexErrMsg = $ele.data('validation-regex-error-msg'),
        apiValReq = $ele.data('api-address-validation'),
        apiValReqErrMsg = $ele.data('api-error-msg'),
        apiValValid = $ele.attr('data-api-address-validation-valid'),
        valErrMsg = '';

    $ele.closest('.ph-form__fieldwrap').removeClass('ph-form_field_error');
    $ele.closest('.ph-form__fieldwrap').find('.ph-validation-error-msg').addClass('hidden').text();

    if ($ele.is('input')) {
      if (inpMandatory === true) {
        if ($ele.val() === '') {
          valErrMsg = validationErrMsg;
        } else if (regex !== null && regex !== '' && !regex.test($ele.val())) {
          valErrMsg = validationRegexErrMsg;
        } else if (apiValReq === true && apiValValid === 'false') {
          valErrMsg = apiValReqErrMsg;
        }
      }
    } else if ($ele.is('select')) {
      if (inpMandatory === true) {
        if ($ele.val() === '' || $ele.val() === null) {
          valErrMsg = validationErrMsg;
        } else if (apiValReq === true && apiValValid === 'false') {
          valErrMsg = apiValReqErrMsg;
        }
      }
    }

    if (valErrMsg !== '') {
      $ele.closest('.ph-form__fieldwrap').addClass('ph-form_field_error');
      $ele.closest('.ph-form__fieldwrap').find('.ph-validation-error-msg').removeClass('hidden').text(valErrMsg);

      return false;
    }

    return true;
  }

  function checkFormValidation(form) {
    var inpElems = $(form).find('input[type="text"]'),
        selectElems = $(form).find('select'),
        flag = true;

    for (var inpLen = 0; inpLen < inpElems.length; inpLen = inpLen + 1) {
      validateCustomerDetailsField(inpElems[inpLen]) === false ? flag = false : '';
    }

    for (var selLen = 0; selLen < selectElems.length; selLen = selLen + 1) {
      validateCustomerDetailsField(selectElems[selLen]) === false ? flag = false : '';
    }

    return flag;
  }

  $(document).on('click', '#ph-profile-customer-form-submit', function(event) {
    var $form = $(this).closest('form'),
        // eslint-disable xss/no-mixed-html
        $submittingForm = $('#submittingForm'),
        fieldMappingArray = {},
        $customerDetailsFormEleList = $('#colorbox .ph-customer-details-form .ph-customer-details-form-element'),
        $biliingAddressFormList = $('#colorbox .ph-billing-address-form'),
        $shippingAddressFormList = $('#colorbox .ph-shipping-address-form');


    event.preventDefault();
    event.stopPropagation();

    if (!checkFormValidation($form)) {
      return false;
    }

    fieldMappingArray = {
      companyName: 'orgName',
      companyName2: 'orgName2',
      companyName3: 'orgName3',
      companyName4: 'orgName4',
      emailAddress: 'emailAddress',
      phoneNumber: 'phoneNumber',
      vatNumber: 'vatNumber',
      sleeveText: 'customizedSleeveText[]',
      medicalLicenseNumber: 'medicalLicenseNumber',
      'ph-input-billing-address-id': 'id',
      'billingAddressList.streetName': 'streetName',
      'billingAddressList.streetNumber': 'streetNumber',
      'billingAddressList.streetNumber2': 'streetNumber2',
      'billingAddressList.street2': 'street2',
      'billingAddressList.houseNumber': 'houseNumber',
      'billingAddressList.postcode': 'postcode',
      'billingAddressList.townCity': 'townCity',
      'billingAddressList.countryIso': 'countryIso',
      'billingAddressList.regionIso': 'regionIso',
      'ph-input-shipping-address-id': 'id',
      'shippingAddressList.companyName': 'company',
      'shippingAddressList.streetName': 'streetName',
      'shippingAddressList.streetNumber': 'streetNumber',
      'shippingAddressList.streetNumber2': 'streetNumber2',
      'shippingAddressList.street2': 'street2',
      'shippingAddressList.houseNumber': 'houseNumber',
      'shippingAddressList.postcode': 'postcode',
      'shippingAddressList.townCity': 'townCity',
      'shippingAddressList.countryIso': 'countryIso',
      'shippingAddressList.regionIso': 'regionIso'
    };

    /* eslint-disable xss/no-mixed-html */
    for (var cdLen = 0; cdLen < $customerDetailsFormEleList.length; cdLen = cdLen + 1) {
      // eslint-disable-next-line no-prototype-builtins
      var fieldName = fieldMappingArray.hasOwnProperty($($customerDetailsFormEleList[cdLen]).attr('name')) ? fieldMappingArray[$($customerDetailsFormEleList[cdLen]).attr('name')] : $($customerDetailsFormEleList[cdLen]).attr('name');

      $submittingForm.append('<input type="text" name="' + fieldName + '" value="' + $($customerDetailsFormEleList[cdLen]).val() + '" />');
    }

    for (var baListLen = 0; baListLen < $biliingAddressFormList.length; baListLen = baListLen + 1) {
      var $biliingAddressEleList = $($biliingAddressFormList[baListLen]).find('.ph-customer-details-form-element');

      for (var baLen = 0; baLen < $biliingAddressEleList.length; baLen = baLen + 1) {
        // eslint-disable-next-line no-prototype-builtins
        var bfieldName = fieldMappingArray.hasOwnProperty($($biliingAddressEleList[baLen]).attr('name')) ? fieldMappingArray[$($biliingAddressEleList[baLen]).attr('name')] : $($biliingAddressEleList[baLen]).attr('name'),
            bInpEleName = 'billingAddress[' + baListLen + '].' + bfieldName;

        $submittingForm.append('<input type="text" name="' + bInpEleName + '" value="' + $($biliingAddressEleList[baLen]).val() + '" />');
      }
    }


    for (var saListLen = 0; saListLen < $shippingAddressFormList.length; saListLen = saListLen + 1) {
      var $shippingAddressEleList = $($shippingAddressFormList[saListLen]).find('.ph-customer-details-form-element');

      for (var saLen = 0; saLen < $shippingAddressEleList.length; saLen = saLen + 1) {
        // eslint-disable-next-line no-prototype-builtins
        var sfieldName = fieldMappingArray.hasOwnProperty($($shippingAddressEleList[saLen]).attr('name')) ? fieldMappingArray[$($shippingAddressEleList[saLen]).attr('name')] : $($shippingAddressEleList[saLen]).attr('name'),
            sInpEleName = 'shippingAddress[' + saListLen + '].' + sfieldName;

        $submittingForm.append('<input type="text" name="' + sInpEleName + '" value="' + $($shippingAddressEleList[saLen]).val() + '" />');
      }
    }

    $submittingForm.submit();
    /* eslint-enable xss/no-mixed-html */

    return false;
  });

  $(document).on('change', 'select[ data-onchange-ajax-load="true"]', function() {
    var $ele = $(this),
        targetAjaxurl = $ele.data('target-ajaxurl'),
        targetEle = $ele.data('onchange-target-ele'),
        targetAjaxParams = $ele.data('target-ajax-params'),
        dependentGroup = $ele.data('dependent-group'),
        reqParams = {},
        targetSelEle = '';

    targetSelEle = $('.ph-' + dependentGroup + '-' + targetEle);
    targetSelEle.val([]).find('option:selected').prop('selected', false).removeAttr('selected');
    reqParams[targetAjaxParams] = $ele.val();

    $.ajax({
      type: 'POST',
      data: reqParams,
      cache: false,
      url: ACC.config.encodedContextPath + targetAjaxurl,
      success: function(response) {
        var htmlcontent = '';

        if (response.length > 0) {
          var selected = '';

          htmlcontent = '<option value="" selected >Please select</option>';

          // eslint-disable-next-line guard-for-in
          for (var item in response) {
            // eslint-disable-next-line xss/no-mixed-html
            htmlcontent = htmlcontent + '<option value="' + response[item].isocode + '" ' + selected + ' >' + response[item].name + '</option>';
          }

          // eslint-disable-next-line xss/no-mixed-html
          targetSelEle.html(htmlcontent);
        }
      }
    });
  });

  $(document).on('click', '.ph-popup-subsection-header', function() {
    var targetEle = $(this).attr('data-target');

    $(this).toggleClass('ph-icon-arrow-up ph-icon-arrow-down');
    $(targetEle).slideToggle(250);
  });

  $(document).on('change', '.ph-billing-address-elem, .ph-shipping-address-elem', function() {
    var addressValidationRequired = $('#ph-addressValidationRequired').val();

    if (addressValidationRequired === 'true') {
      var addressGroup = $(this).attr('data-dependent-group'),
          $streetNameEle = $('#colorbox .ph-' + addressGroup + '-streetName'),
          $houseNumberEle = $('#colorbox .ph-' + addressGroup + '-houseNumber'),
          $postalCodeEle = $('#colorbox .ph-' + addressGroup + '-postcode'),
          $townCityEle = $('#colorbox .ph-' + addressGroup + '-townCity'),
          $countryIsoEle = $('#colorbox .ph-' + addressGroup + '-countryIso'),
          $regionIsoEle = $('#colorbox .ph-' + addressGroup + '-regionIso'),
          streetName = $streetNameEle.val(),
          houseNumber = $houseNumberEle.val(),
          postalCode = $postalCodeEle.val(),
          townCity = $townCityEle.val(),
          countryIso = $countryIsoEle.val(),
          regionIso = $regionIsoEle.val(),
          flag = true;

      $('[data-dependent-group="' + addressGroup + '"]')
        .attr('data-api-address-validation-valid', 'true')
        .closest('.ph-signup__error')
        .find('.ph-validation-error-msg')
        .removeClass('ph-blueError')
        .addClass('hidden')
        .text('');

      validateCustomerDetailsField($streetNameEle) === false ? flag = false : '';
      validateCustomerDetailsField($houseNumberEle) === false ? flag = false : '';
      validateCustomerDetailsField($postalCodeEle) === false ? flag = false : '';
      validateCustomerDetailsField($townCityEle) === false ? flag = false : '';
      validateCustomerDetailsField($countryIsoEle) === false ? flag = false : '';
      validateCustomerDetailsField($regionIsoEle) === false ? flag = false : '';

      if (flag) {
        $.ajax({
          type: 'POST',
          data: {
            addressForm: JSON.stringify({
              countryIso: countryIso,
              regionIso: regionIso,
              streetName: streetName,
              houseNumber: houseNumber,
              postcode: postalCode,
              townCity: townCity
            })
          },
          cache: false,
          url: ACC.config.encodedContextPath + '/my-account/profile/validate-address',
          success: function(response) {
            var errorKey = response.errorKey,
                fieldDetails = response.fieldDetails;

            if (errorKey !== null && errorKey !== '') {
              var dataApiErrorMsg = $('#colorbox .ph-' + addressGroup + '-' + errorKey).attr('data-api-error-msg');

              $('#colorbox .ph-' + addressGroup + '-' + errorKey)
                .attr('data-api-address-validation-valid', 'false')
                .closest('.ph-signup__error')
                .addClass('form_field_error ph-form_field_error')
                .find('.ph-validation-error-msg')
                .removeClass('ph-validation-blue-msg')
                .text(dataApiErrorMsg);
            }

            // eslint-disable-next-line guard-for-in
            for (var indx in fieldDetails) {
              var $ele = $('#colorbox .ph-' + addressGroup + '-' + fieldDetails[indx].fieldName),
                  dataApiAddressValUpdateMsg = $ele.data('api-address-validation-generic-success-msg');

              $ele.val(fieldDetails[indx].fieldValue)
                .closest('.ph-signup__error')
                .find('.ph-validation-error-msg')
                .addClass('ph-validation-blue-msg')
                .text(dataApiAddressValUpdateMsg)
                .removeClass('hidden');
            }
          }
        });
      }
    }
  });

  function loadSelectOptionList(ajaxurl, ele) {
    var dependentField = ele.data('dependent-field'),
        dependentGroup = ele.data('dependent-group'),
        ajaxParams = '',
        dependentFieldVal = '',
        reqParams = {};

    ajaxParams = ele.data('ajax-params');
    dependentFieldVal = $('.ph-' + dependentGroup + '-' + dependentField).find('option:selected').val();
    reqParams[ajaxParams] = dependentFieldVal;

    $.ajax({
      type: 'POST',
      data: reqParams,
      cache: false,
      url: ACC.config.encodedContextPath + ajaxurl,
      success: function(response) {
        var htmlcontent = '',
            selValue = ele.data('field-value');

        if (response.length > 0) {
          var selected = '';

          // eslint-disable-next-line guard-for-in
          for (var item in response) {
            // eslint-disable-next-line no-extra-parens
            selected = (selValue !== '' && selValue === response[item].isocode) ? 'selected' : '';

            // eslint-disable-next-line xss/no-mixed-html
            htmlcontent = htmlcontent + '<option value="' + response[item].isocode + '" ' + selected + ' >' + response[item].name + '</option>';
          }

          // eslint-disable-next-line xss/no-mixed-html
          ele.append(htmlcontent);
        }
      }
    });
  }

  (function() {
    var selectElems = $('#customerDetailsEditForm').find('select'),
        ajaxLoadRequired = '',
        ajaxurl = '';

    for (var selLen = 0; selLen < selectElems.length; selLen = selLen + 1) {
      ajaxLoadRequired = $(selectElems[selLen]).data('ajax-required');
      ajaxurl = $(selectElems[selLen]).data('ajax-url');

      if (ajaxLoadRequired === true) {
        loadSelectOptionList(ajaxurl, $(selectElems[selLen]));
      }
    }
  })();

  $(document).on('change, blur', '.ph-company-details-elem', function() {
    var $ele = $(this);

    validateCustomerDetailsField($ele);
  });
});

/* J-query changes for Generated order reports page - AR20087697 */
$(document).ready(function() {
  if (location.hash.includes('#contract-sec')) {
    setTimeout(function() {
      $(window).scrollTop($('.ph-contractSection').offset().top - 100);
    }, 50);
  }
});
$(document).ready(function() { // NOSONAR
  var resultlength = 0,
      reportgenerate = '';

  localStorage.setItem(reportgenerate, 'true');

  localStorage.setItem(resultlength, 0);

  var getresult = localStorage.getItem(resultlength);

  function decidelogoicon(genreposdoclink, genrepostatus) {
    var genrepoicon = [];

    if (genrepostatus === 'inprogress') {
      genrepoicon[0] = 'ph-genreploadlogo';
      genrepoicon[1] = 'ph-genrepindicatorcircleblue';
      genrepoicon[2] = 'ph-genreploadpointerevt';
      $('#ph-dummyrow').hide();
    } else if (genrepostatus === 'success') {
      genrepoicon[0] = 'ph-genrepdwnldlogo';
      genrepoicon[1] = 'ph-genrepindicatorcirclegreen';
      genrepoicon[2] = '';
    } else {
      genrepoicon[0] = '';
      genrepoicon[1] = 'ph-genrepindicatorcirclered';
      genrepoicon[2] = '';
    }

    return genrepoicon;
  }

  function genrepcontentgenerator() {
    var content = '',
        genreprefno = '',
        decidelogo = [],
        genrep = 0,
        genrepresult = '',
        inprogresscontent = '',
        inprogressgenerate = $('.ph-inprogressgenerate').val(),
        genrepobar = '.ph-genrepo-bar',
        reportdone = '',
        /* eslint-disable xss/no-mixed-html */
        divContentWithClass = '<div class="ph-d-lg-flex ph-flex-row ph-widthclass">';
        /* eslint-enable xss/no-mixed-html */


    $.ajax({
      url: ACC.config.encodedContextPath + '/reports/updateStatus',
      type: 'POST',
      datatype: 'json',
      success: function(result) {
        for (genrep = 0; genrep < result.length; genrep = genrep + 1) {
          decidelogo = decidelogoicon(result[genrep].mediaUrl, result[genrep].status);
          genrepresult = result[genrep];

          if (genrepresult.referenceNumber === null) {
            genreprefno = genrepresult.report;
          } else {
            genreprefno = genrepresult.referenceNumber + ' - ' + genrepresult.report;
          }

          /* eslint-disable xss/no-mixed-html */
          reportdone = localStorage.getItem(reportgenerate);

          content = content + '<div class="ph-d-flex ph-flex-row ph-p-1 ph-m-sm-2 ph-genrepbox">' + divContentWithClass +
            '<div class="ph-profilebox16font ph-mr-sm-2 ph-genreportname ph-font-weight-bold">' + genreprefno + '</div>' +
            '<div class="ph-profilebox16font ph-mr-sm-2 ph-genreporttimestamp ph-text-lg-center">' + genrepresult.formatedDateTime +
            '</div>' +
            '<div class="ph-d-flex ph-flex-row ph-mr-2  ph-genreportstatus">' +
            '<div class="ph-genrepindicator">' +
            '<div class="' + decidelogo[1] + '"></div>' +
            '</div>' +
            '<div class="ph-profilebox16font ' + decidelogo[1] + '-check">' + genrepresult.localizedStatus + '</div>' +
            '</div>' +
            '</div>' +
            '<div class="ph-genreporticonposition"><a href="' + genrepresult.mediaUrl + '" class="' + decidelogo[2] +
            '"><div class="' + decidelogo[0] + '"></div></a></div>' +
            '</div>';
          /* eslint-enable xss/no-mixed-html */
        }

        /* eslint-disable xss/no-mixed-html */
        if (getresult === '0') {
          inprogresscontent = '<div id="ph-dummyrow"><div class="ph-d-flex ph-flex-row ph-p-1 ph-m-sm-2 ph-genrepbox">' + divContentWithClass +
            '<div class="ph-profilebox16font ph-mr-sm-2 ph-genreportname ph-font-weight-bold"></div>' +
            '<div class="ph-profilebox16font ph-mr-sm-2 ph-genreporttimestamp ph-text-lg-center"></div>' +
            '<div class="ph-d-flex ph-flex-row ph-mr-2  ph-genreportstatus"><div class="ph-genrepindicator">' +
            '<div class="ph-genrepindicatorcircleblue"></div></div><div class="ph-profilebox16font">' + inprogressgenerate + '</div></div></div>' +
            '<div class="ph-genreporticonposition"><a  class="ph-genreploadpointerevt"><div class="ph-genreploadlogo"></div></a></div></div></div>';
          $(genrepobar).prepend(inprogresscontent);
        }


        var lengthres = result.length;

        getresult = localStorage.getItem(resultlength);

        if (getresult < lengthres && getresult !== '0') {
          $('#ph-dummyrow').hide();
          localStorage.setItem(resultlength, -1);
          localStorage.setItem(reportgenerate, 'false');
        }

        localStorage.setItem(resultlength, lengthres);

        getresult = localStorage.getItem(resultlength);

        $(genrepobar).html(content);

        if (content !== '') {
          $('#ph-dummyrowdom').hide();
        }

        if (getresult > '0' && reportdone === 'true' && window.location.href.indexOf('reporttrigger') !== -1) {
          inprogresscontent = '<div id="ph-dummyrow"><div class="ph-d-flex ph-flex-row ph-p-1 ph-m-sm-2 ph-genrepbox">' + divContentWithClass +
            '<div class="ph-profilebox16font ph-mr-sm-2 ph-genreportname ph-font-weight-bold"></div>' +
            '<div class="ph-profilebox16font ph-mr-sm-2 ph-genreporttimestamp ph-text-lg-center"></div>' +
            '<div class="ph-d-flex ph-flex-row ph-mr-2  ph-genreportstatus"><div class="ph-genrepindicator">' +
            '<div class="ph-genrepindicatorcircleblue"></div></div><div class="ph-profilebox16font">' + inprogressgenerate + '</div></div></div>' +
            '<div class="ph-genreporticonposition"><a  class="ph-genreploadpointerevt"><div class="ph-genreploadlogo"></div></a></div></div></div>';
          $(genrepobar).prepend(inprogresscontent);
          localStorage.setItem(reportgenerate, 'false');
        }

        /* eslint-enable xss/no-mixed-html */
      }

    });
  }

  if ($('.ph-genreportcontent').length > 0) {
    setInterval(function() {
      genrepcontentgenerator();
    }, 10000);

    if (window.location.href.indexOf('reporttrigger') !== -1) {
      $('#ph-dummyrowdom').show();
    }

    genrepcontentgenerator();
  }
});

$(document).ready(function() {
  var signerrormsgedit = 'signup__error';
  var errFormfield = 'form_field_error ph-form_field_error';
  var errorEmptyField = 'register__emptyvalue';
  var contractrenewalquestionpage = '.ph-contractrenewalquestionpage',
      editcontractdetailspage = '.ph-editcontractdetailspage',
      globalerrormsg = '.ph-hideediterror',
      fieldemptydetails = '.ph-contract__personaldetails .ph-fieldemptydetails';

  $('.ph-contractrenewalquestionpage').hide();
  $('.ph-editcontractdetailspage').show();

  ACC.contractrenewalpage.contractMandatoryCheck();

  $(document).on('click', '.ph-contractshowquestion', function() {
    var emptycheckcount = true;

    $(fieldemptydetails).each(function() {
      var contCompanyDetails = $(this).text();

      if (!contCompanyDetails) {
        emptycheckcount = false;
        $(globalerrormsg).removeClass('hidden');
        $(contractrenewalquestionpage).hide();
        $(editcontractdetailspage).show();
      }
    });

    if (emptycheckcount === true) {
      $(globalerrormsg).addClass('hidden');
      $(contractrenewalquestionpage).show();
      $(editcontractdetailspage).hide();
    }
  });
  $(document).on('click', '.ph-upadate__contrctdetails', function() {
    $.colorbox({
      maxWidth: '500px',
      width: '95%',
      height: 'auto',
      scrolling: true,
      top: '10%',
      /* eslint-disable xss/no-mixed-html */
      html: $('.ph-contract__editdetailspopup').html(),
      /* eslint-enable xss/no-mixed-html */
      onComplete: function() {
        ACC.common.refreshScreenReaderBuffer();
        $('.ph-' + errorEmptyField).css('display', 'none');
        $('.ph-' + signerrormsgedit).removeClass(errFormfield);
        $('.ph-firstName').val($('.ph-finame').text());
        $('.ph-lastName').val($('.ph-liname').text());
        $('.ph-phoneNumber').val($('.ph-contphone').text());
        $('.ph-address').val($('.ph-contaddress').text());
        $('.ph-city').val($('.ph-contractcity').text());
        $('.ph-country').val($('.ph-contractcountry').text());
        $('.ph-companyName').val($('.ph-contactcompany').text());
        $('.ph-vatNumber').val($('.ph-contractvat').text());
        $('.ph-email').val($('.ph-emailadd').text());

        ACC.contractrenewalpage.contractEditBtnCheck();
      },
      onClosed: function() {
        var emptycheckcount = true;

        ACC.common.refreshScreenReaderBuffer();

        $(fieldemptydetails).each(function() {
          var contCompanyDetails = $(this).text();

          if (!contCompanyDetails) {
            emptycheckcount = false;
            $(globalerrormsg).removeClass('hidden');
          }
        });

        if (emptycheckcount === true) {
          $(globalerrormsg).addClass('hidden');
        }
      }

    });
    $('.ph-' + signerrormsgedit).removeClass('hidden');
  });


  $(document).on('click', '.ph-savecontractdetails', function() {
    var $form = $('#cboxContent #updateContractForm');
    var editinfoiputfield = '#cboxContent #updateContractForm .ph-inputData';
    var contractemailValue = $('#cboxContent #ph-emailAddress input').val();
    var validationstatus = true;
    var emailcontvar = '#cboxContent #ph-emailAddress';
    var colorboxvalid = '#cboxContent #';

    $(editinfoiputfield).each(function() {
      var inputId = $(this).attr('id'),
          inputValue = $(this).find('input').val(),
          errormsgValue = $(colorboxvalid + inputId).attr('data-emptyContent');

      /* eslint-disable no-undefined */
      if (inputValue === '' || inputValue === null || inputValue === undefined || $.trim(inputValue) === '') {
        /* eslint-enable no-undefined */
        $(colorboxvalid + inputId).find('.ph-form__fieldwrap').addClass(errFormfield);
        $(colorboxvalid + inputId).find('.ph-' + errorEmptyField).text(errormsgValue).css('display', 'block');

        validationstatus = false;
      } else {
        $(colorboxvalid + inputId).find('.ph-form__fieldwrap').removeClass(errFormfield);
        $(colorboxvalid + inputId).find('.ph-' + errorEmptyField).text('');
      }
    });

    if (ACC.validation.email(contractemailValue)) {
      $(emailcontvar).find('.ph-signup__error').addClass(errFormfield);
      $(emailcontvar).find('.ph-' + errorEmptyField).text($(emailcontvar).attr('data-emptyContent'));

      validationstatus = false;
    }

    if (validationstatus === true) {
      $.ajax({
        url: ACC.config.encodedContextPath + '/contractrenewal/updateContractRenewalDetails',
        type: 'POST',
        data: $form.serialize(),
        datatype: 'json',
        success: function(response) {
          $('.ph-finame').html(response.firstName);
          $('.ph-liname').html(response.lastName);
          $('.ph-contphone').html(response.phoneNumber);
          $('.ph-contaddress').html(response.address);
          $('.ph-contractcity').html(response.city);
          $('.ph-contractcountry').html(response.country);
          $('.ph-contactcompany').html(response.companyName);
          $('.ph-contractvat').html(response.vatNumber);
          $('.ph-emailadd').html(response.email);

          ACC.contractrenewalpage.contractSaveBtnCheck(response);
          $.fn.colorbox.close();
        }
      });
    }
  });
});
/* J-query changes for Generated order reports page - AR20087697 */

$(document).on('click', '.ph-expanded__popup', function() {
  $.colorbox({
    maxWidth: '90%',
    width: '100%',
    height: 'auto',
    maxHeight: '88%',
    scrolling: false,
    /* eslint-disable xss/no-mixed-html */
    html: $('.ph-payment__balance_popup').html(),
    /* eslint-enable xss/no-mixed-html */
    onClosed: function() {
      ACC.common.refreshScreenReaderBuffer();
    }

  });
});

$(document).on('click', '.ph-paymentbalance__close', function() {
  $.colorbox.close();
});

$(document).on('mouseout', '.ph-icon-profile', function() {
  $(this).siblings('.ph-profile__preferred_popup').addClass('hidden');
});
$(document).on('mouseover', '.ph-icon-profile', function() {
  $(this).siblings('.ph-profile__preferred_popup').removeClass('hidden');
});
/* eslint-enable max-lines-per-function */
/* eslint-enable no-unused-expressions */
/* eslint-enable no-ternary */
/* eslint-enable complexity */
/* eslint-enable max-len */
/* eslint-enable require-jsdoc */
/* eslint-enable no-inline-comments */
/* eslint-enable line-comment-position */
/* eslint-enable max-lines */
/* eslint-enable vars-on-top */
/* eslint-enable max-statements */
